import {
  BwArchiveAttachment,
  BwAudioAttachment,
  BwImageAttachment,
  BwPdfAttachment,
  BwPptAttachment,
  BwSheetAttachment,
  BwTextAttachment,
  BwVideoAttachment,
  BwWordAttachment,
} from "@/components/ui/icons";
import {
  getFileExtension,
  getFileExtensionFromMimeType,
  isArchive,
  isDocument,
  isPdf,
  isPpt,
  isRtf,
  isSheet,
} from "@/libs/file-helper";
import { classifyAttachmentKind } from "./attachment-kind";

function iconFor(fileExtension: string, contentType?: string | null) {
  const kind = classifyAttachmentKind(fileExtension, contentType);
  if (kind === "image") return BwImageAttachment;
  if (kind === "video") return BwVideoAttachment;
  if (kind === "audio") return BwAudioAttachment;
  if (isPdf(fileExtension) || isRtf(fileExtension)) return BwPdfAttachment;
  if (isSheet(fileExtension)) return BwSheetAttachment;
  if (isArchive(fileExtension)) return BwArchiveAttachment;
  if (isDocument(fileExtension)) return BwWordAttachment;
  if (isPpt(fileExtension)) return BwPptAttachment;
  return BwTextAttachment;
}

/**
 * The type icon a file is drawn with (image, video, audio, PDF, sheet, …) — what a tile
 * falls back to when there is no picture to show.
 */
export function AttachmentTypeIcon({
  fileName,
  contentType,
  size,
  className,
}: {
  fileName: string;
  contentType?: string | null;
  size?: number;
  className?: string;
}) {
  const fileExtension =
    getFileExtension(fileName) ||
    getFileExtensionFromMimeType(contentType ?? "");
  const Icon = iconFor(fileExtension, contentType);
  return <Icon size={size} className={className} />;
}
